/* ============================================================
   AVISE-ME QUANDO VOLTAR — SETH STORE
   Captura email e envia pro ActiveCampaign via JSONP.
   ============================================================ */

(function() {
  'use strict';

  function init() {
    var container = document.querySelector('[data-seth-aviseme]');
    if (!container || container.dataset.sethAvisemeInit === '1') return;
    container.dataset.sethAvisemeInit = '1';

    var form = container.querySelector('[data-seth-aviseme-form]');
    var input = container.querySelector('[data-seth-aviseme-input]');
    var btn = container.querySelector('[data-seth-aviseme-btn]');
    var sucesso = container.querySelector('[data-seth-aviseme-sucesso]');
    var erro = container.querySelector('[data-seth-aviseme-erro]');

    if (!form || !input || !btn || !sucesso || !erro) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      erro.hidden = true;
      erro.textContent = '';

      var email = input.value.trim();
      if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        erro.textContent = 'Digite um email válido.';
        erro.hidden = false;
        return;
      }

      btn.disabled = true;
      btn.textContent = 'ENVIANDO...';

      var formData = new FormData(form);
      var params = new URLSearchParams();
      formData.forEach(function(value, key) {
        params.append(key, value);
      });

      var script = document.createElement('script');
      script.src = 'https://sethstore.activehosted.com/proc.php?' + params.toString() + '&jsonp=true';

      window._show_thank_you = function() {
        form.style.display = 'none';
        sucesso.hidden = false;
      };
      window._show_error = function(id, message) {
        btn.disabled = false;
        btn.textContent = 'ME AVISE';
        erro.textContent = message || 'Ops, algo deu errado. Tente novamente.';
        erro.hidden = false;
      };
      window._show_unsubscribe = function() {};
      window._show_pc_confirmation = function() {};
      window.cfields = window.cfields || [];

      script.onerror = function() {
        btn.disabled = false;
        btn.textContent = 'ME AVISE';
        erro.textContent = 'Não conseguimos enviar agora. Tente novamente em instantes.';
        erro.hidden = false;
      };

      document.head.appendChild(script);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();